var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 22.2857H20.4286C20.9211 22.2857 21.3935 22.0901 21.7418 21.7418C22.0901 21.3935 22.2857 20.9211 22.2857 20.4286V11.1429H11.1429V22.2857ZM7.42857 22.2857V11.1429H3.71429V20.4286C3.71429 20.9211 3.90995 21.3935 4.25823 21.7418C4.60651 22.0901 5.07888 22.2857 5.57143 22.2857H7.42857ZM22.2857 5.57143C22.2857 5.07888 22.0901 4.60651 21.7418 4.25823C21.3935 3.90995 20.9211 3.71429 20.4286 3.71429H5.57143C5.07888 3.71429 4.60651 3.90995 4.25823 4.25823C3.90995 4.60651 3.71429 5.07888 3.71429 5.57143V7.42857H22.2857V5.57143ZM5.57143 0H20.4286C21.9062 0 23.3233 0.586988 24.3682 1.63183C25.413 2.67668 26 4.09379 26 5.57143V20.4286C26 21.9062 25.413 23.3233 24.3682 24.3682C23.3233 25.413 21.9062 26 20.4286 26H5.57143C4.09379 26 2.67668 25.413 1.63183 24.3682C0.586988 23.3233 0 21.9062 0 20.4286L0 5.57143C0 4.09379 0.586988 2.67668 1.63183 1.63183C2.67668 0.586988 4.09379 0 5.57143 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/Gallery.c9b9e078d234167d8c7a91243ebdd50f.svg";
export { ForwardRef as ReactComponent };